<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-header-txt">{{ $t('edit_user') }}</span>
        </div>
        <div class="forms">
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{ $t('name_expert') }}</span>
              <input type="text" class="form-input" :placeholder="$t('enter_name')" v-model="userData.name" />
            </div>
            <div class="form-div">
              <span class="form-title">{{ $t('surname_person') }}</span>
              <input type="text" class="form-input" :placeholder="$t('enter_surname')" v-model="userData.surname" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{ $t('email_address') }}</span>
              <input type="text" class="form-input" :placeholder="$t('enter_email')" v-model="userData.email" />
            </div>
            <div class="form-div">
              <span class="form-title">{{ $t('phone_number_person') }}</span>
              <PhoneInput v-model="userData.phone" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{ $t('birthday') }}</span>
              <input type="text" class="form-input" :placeholder="$t('birthday')" v-model="userData.birthday" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{ $t('company_name') }}</span>
              <input type="text" class="form-input" :placeholder="$t('company_name')" v-model="userData.companyName" />
            </div>
          </div>
          <div class="double-form">
            <div class="form-div">
              <span class="form-title">{{ $t('department') }}</span>
              <input type="text" class="form-input" :placeholder="$t('department')" v-model="userData.departmentNames" />
            </div>
          </div>
        </div>
        <div class="btn-div" @click="onSave">
          <div class="btn-style">
            <span class="next-txt" v-if="!loading">{{ $t('save_button') }}</span>
            <VueSpinnerIos v-if="loading" size="20" height="100%" color="#fff" />
          </div>
        </div>
        <div @click="onHide" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { VueSpinnerIos } from 'vue3-spinners';
import userService from "@/service/userService";
import { handleErrorResponse } from "@/utils/utils";
import PhoneInput from "@/components/PhoneInput.vue";

export default {
  components: {
    PhoneInput,
    VueSpinnerIos
  },
  props: {
    editData: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      userData: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        birthday: '',
        companyName: '',
        departmentNames: ''
      },
      loading: false
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.userData = {
            name: this.editData.name || '',
            surname: this.editData.surname || '',
            email: this.editData.email || '',
            phone: this.editData.phone || '',
            birthday: this.editData.birthday || '',
            companyName: this.editData.companyName || '',
            departmentNames: (this.editData.departments || []).map(d => d.name).join(', ')
          };
        } else {
          this.resetForm();
        }
      }
    }
  },
  methods: {
    resetForm() {
      this.userData = {
        name: '',
        surname: '',
        email: '',
        phone: '',
        birthday: '',
        companyName: '',
        departmentNames: ''
      };
    },
    onSave() {
      this.loading = true;

      const formData = new FormData();
      formData.append('userId', this.editData.userId);
      formData.append('status', this.editData.status ? 1 : 0);
      formData.append('roleId', this.editData.roleId);
      formData.append('name', this.userData.name);
      formData.append('surname', this.userData.surname);
      formData.append('email', this.userData.email);
      formData.append('phoneNumber', this.userData.phone);
      formData.append('birthday', this.userData.birthday);
      formData.append('companyName', this.userData.companyName);
      formData.append('departments', this.userData.departmentNames);

      userService.editUser(formData).then(() => {
        this.loading = false;
        this.onHide();
        this.refreshCallback();

        this.$snackbar.add({
          type: 'success',
          text: this.$t('user_updated_successfully')
        });
      }).catch((error) => {
        this.loading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross {
  padding: 8px;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}

.modal-header-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.forms {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  align-items: flex-start;
  width: 100%;
}

.double-form {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}

.form-div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}

.form-title {
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.btn-style {
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}

.next-txt {
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.btn-div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
</style>